import { Component } from "@angular/core";
import { HeaderComponent } from "../../header/header.component";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { CrmService } from "src/app/service/crm.service";
import { provideNativeDateAdapter } from "@angular/material/core";

@Component({
    selector: "app-dashboard",
    imports: [
        HeaderComponent,
        MatFormFieldModule,
        MatDatepickerModule,
        MatInputModule,
        MatButtonModule,
    ],
    providers: [MatDatepickerModule, provideNativeDateAdapter()],
    templateUrl: "./dashboard.component.html",
    styleUrl: "./dashboard.component.css"
})
export class DashboardComponent {


  constructor(private crmService: CrmService) {

  }
}
